import { getLocalizedNumber } from '../localization';

export class Metadata {
  constructor(metadata) {
    this.requestTokenUrl = metadata?.checkout_payment_url || null;
    this.requestPaymentUrl = metadata?.register_payment_url || null;
    this.publishableKey = metadata?.publishable_key || null;
    this.price = metadata?.pretty_price || null;
    const phoneObject = splitCountryCodeAndPhone(metadata?.phone_number);
    this.countryCode = phoneObject ? phoneObject.countryCode : null;
    this.phoneNumber = phoneObject ? phoneObject.phone : null;
    this.subscriptionId = metadata?.subscription_id || null;
    this.planId = metadata?.plan_id || null;
    this.addressId = metadata?.address_id || null;
    this.voucherCode = metadata?.voucher_code || null;
    this.subTotal = metadata?.sub_total || null;
    this.amount = metadata?.amount ? Number(metadata?.amount / 100) : null;
    this.clientId = metadata?.client_id || null;
    this.taxes = metadata?.taxes || null;
    this.discount = metadata?.voucher_discount || null;
    this.discountAmount = metadata?.voucher_discount_amount || null;
    this.currency = metadata?.currency || null;
    this.voucherType = metadata?.voucher_type || null;
    this.promotedBankName = metadata?.promoted_bank_name || null;
    this.promotedBankNote = metadata?.promoted_bank_note || '';
    this.programDiscount = metadata?.program_discount || null;
    this.merchantIdentifier = metadata?.apple_pay_merchant_identifier || null;
    this.priceAfterDisscount = metadata?.final_price_after_taxes || null;
    this.addonId = metadata?.addon_id || null;
    this.discountAppliedOnAddon =
      metadata?.discount_applied_on_addon !== undefined
        ? metadata.discount_applied_on_addon
        : null;
    this.addonPrice = metadata?.addon_price || null;
    this.isPaidWithWallet =
      metadata?.is_paid_with_wallet !== undefined
        ? metadata?.is_paid_with_wallet
        : null;
    this.walletPayment =
      metadata?.wallet_payment !== undefined ? metadata?.wallet_payment : null;
    this.mokafaaAmount =
      metadata?.mokafaa_amount !== undefined ? metadata?.mokafaa_amount : null;
    this.mokafaaTransactionId =
      metadata?.mokafaa_transaction_id !== undefined
        ? metadata?.mokafaa_transaction_id
        : null;
  }

  toJSON = () => ({
    checkout_payment_url: this?.requestTokenUrl,
    register_payment_url: this?.requestPaymentUrl,
    publishable_key: this?.publishableKey,
    pretty_price: this?.price,
    phone_number: `${this?.countryCode}${this?.phoneNumber}`,
    subscription_id: this?.subscriptionId,
    plan_id: this?.planId,
    address_id: this?.addressId,
    voucher_code: this?.voucherCode,
    sub_total: this?.subTotal,
    amount: this.amount,
    client_id: this.clientId,
    taxes: this?.taxes,
    voucher_discount: this?.discount,
    currency: this?.currency,
    voucher_type: this?.voucherType,
    promoted_bank_name: this?.promotedBankName,
    promoted_bank_note: this?.promotedBankNote,
    addon_id: this?.addonId,
    addon_price: this?.addonPrice,
    discount_applied_on_addon: this?.discountAppliedOnAddon,
    is_paid_with_wallet: this?.isPaidWithWallet,
    program_discount: this?.programDiscount,
    final_price_after_taxes: this?.priceAfterDisscount,
    wallet_payment: this?.walletPayment,
    mokafaa_amount: this?.mokafaaAmount,
    mokafaa_transaction_id: this?.mokafaaTransactionId,
  });

  #_prettify = (value) => `${getLocalizedNumber(value)} ${this.currency}`;

  get prettySubTotal() {
    return this.#_prettify(this.subTotal);
  }

  get prettyTaxes() {
    return this.#_prettify(this.taxes);
  }

  get prettyDiscount() {
    return this.#_prettify(this.discount);
  }

  get prettyProgramDiscount() {
    return this.#_prettify(this.programDiscount);
  }

  get prettyPriceAfterDiscount() {
    return this.#_prettify(this.priceAfterDisscount);
  }

  get prettyAddonPrice() {
    return this.#_prettify(this.addonPrice);
  }

  get prettyWalletPayment() {
    return this.#_prettify(this.walletPayment);
  }

  get prettyMokafaaAmount() {
    return this.#_prettify(this.mokafaaAmount);
  }

  get hasPromotedBankDiscount() {
    return this.discount > 0 && this.promotedBankName;
  }
}

const splitCountryCodeAndPhone = (phone) => {
  const SUPPORTED_CODES = ['+966', '+965'];
  const countryCode = phone?.substr(0, 4);
  return SUPPORTED_CODES.includes(countryCode)
    ? {
        countryCode,
        phone: phone.substr(4),
      }
    : null;
};
